// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"930":"eb7ec92f","953":"862e5f47"}[chunkId] + ".chunk.css";
};